import { useEffect, useRef, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

const REDIRECT_URI = import.meta.env.VITE_WARDEN_REDIRECT_URI || undefined

export default function AuthCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState('')

  const didRun = useRef(false)

  useEffect(() => {
    if (didRun.current) return
    didRun.current = true

    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const savedState = sessionStorage.getItem('warden_auth_state')

    if (!code || !state) {
      setError('Invalid authorization response')
      return
    }

    if (state !== savedState) {
      sessionStorage.removeItem('warden_auth_state')
      setError('CSRF validation failed')
      return
    }

    sessionStorage.removeItem('warden_auth_state')

    fetch('/api/auth/callback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, ...(REDIRECT_URI && { redirect_uri: REDIRECT_URI }) }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          localStorage.setItem('nymo_auth_token', data.data.access_token)
          // Full reload to ensure AuthContext picks up the new token
          window.location.href = '/'
        } else {
          setError(data.error || 'Authorization failed')
        }
      })
      .catch(() => setError('Could not complete authorization'))
  }, [searchParams, navigate])

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-6">
      {error ? (
        <div className="w-full max-w-sm text-center">
          <div className="bg-accent-error-light text-accent-error text-sm px-4 py-3 rounded-lg mb-4" role="alert">
            {error}
          </div>
          <a href="/login" className="text-sm text-primary hover:underline font-medium">
            Back to sign in
          </a>
        </div>
      ) : (
        <div className="text-center">
          <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-sm text-text-muted">Completing sign in...</p>
        </div>
      )}
    </main>
  )
}
